import { Info, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@tellescope/design-system";

interface RemovedItemsNoticeProps {
  onDismiss: () => void;
}

/**
 * Shown in the cart when one or more items are no longer available (their product was removed
 * from the Shop block's config after being added to the cart). The stale item stays in the cart —
 * and this notice keeps showing — until onDismiss actually removes it; there's no auto-hide.
 */
export const RemovedItemsNotice = ({ onDismiss }: RemovedItemsNoticeProps) => {
  const { t } = useTranslation("shop");

  return (
    <div
      data-test="removed-items-notice"
      className="flex items-start gap-2 text-sm text-muted-foreground bg-muted border border-border rounded-xl p-4 mb-6"
    >
      <Info className="w-4 h-4 flex-shrink-0 mt-0.5" />
      <span className="flex-1">
        {t("One or more items are no longer available and will be removed from your cart.")}
      </span>
      <Button
        variant="ghost"
        iconOnly
        size="xs"
        aria-label={t("Dismiss")}
        onClick={onDismiss}
        className="flex-shrink-0 -m-1"
      >
        <X className="w-4 h-4" />
      </Button>
    </div>
  );
};
